import { ArrowRight } from "lucide-react";
import { Eyebrow, IMAGES, Reveal } from "./shared";

const FILTERS = ["By Destination", "By Field of Study", "By Study Level"];

export const Scholarships = () => (
    <section id="scholarships" data-testid="scholarships-section" className="bg-sand py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
                <Reveal className="lg:col-span-5">
                    <Eyebrow>Scholarships</Eyebrow>
                    <h2 className="mt-5 font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Find Opportunities Worth Pursuing
                    </h2>
                    <p className="mt-6 text-base leading-relaxed text-ink/65">
                        Explore scholarship opportunities by destination, field of study and level — and
                        understand what it takes to prepare a strong application.
                    </p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        {FILTERS.map((filter) => (
                            <span
                                key={filter}
                                data-testid={`scholarship-filter-${filter.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                className="border border-ink/15 px-4 py-2 text-xs font-medium uppercase tracking-[0.18em] text-ink/60"
                            >
                                {filter}
                            </span>
                        ))}
                    </div>
                    <a
                        href="#contact"
                        data-testid="scholarships-explore-btn"
                        className="mt-10 inline-flex items-center gap-2 border border-forest px-8 py-4 text-sm font-medium text-forest transition-colors hover:bg-forest hover:text-ivory"
                    >
                        Explore Scholarships
                        <ArrowRight size={16} strokeWidth={1.5} />
                    </a>
                </Reveal>
                <Reveal delay={0.15} className="lg:col-span-7">
                    <div className="group overflow-hidden">
                        <img
                            src={IMAGES.students}
                            alt="An African student studying with a laptop outdoors"
                            loading="lazy"
                            className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
